import parseDialogue from "../../util/parseDialogue";

export const DisarrayL1 = parseDialogue(`
disarray:l1:100-400

#100 Are you the newbie? I saw you beat the test run.
>200 No sweat.
>200 Who are you?

#200 Fellow S.M.A.R.T agent on patrol. I was just executing some elite hacks in security level two. Where are you headed next?
>300 Just hacking through level one.

#300 Cool. You'll definitely want to grab some better programs. Have you checked out the level one warez node? I'll show you where it is. Later.
>400 Later.
`);
